import { useState } from "react";
import CommonModal from "../../../components/modals/commonModel";
import Lottie from "lottie-react";
import Clock from "../../../assets/lottie/clock.json";
import { BsClockHistory } from "react-icons/bs";
import { IoIosArrowDown } from "react-icons/io";

const PlanExpiryCountdown = ({ expiryDate }) => {
  const [showModal, setShowModal] = useState(false);
  const [show, setShow] = useState(true);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const close = () => {
    setShow(!show);
  };

  return (
    <div className={` fixed bottom-4 right-6`}>
      <div
        onClick={openModal}
        className="flex flex-col rounded-md bg-white cursor-pointer border"
      >
        <div className="flex justify-between items-center font-medium px-4 py-1 w-full">
          <span className="text-[10px] flex gap-2 items-center min-w-40">
            <p className="w-[6px] h-[6px] rounded-full bg-red-500 animate-pulse"></p>
            Trial Information
          </span>
          <div className="flex row gap-1 hover:bg-light rounded-full w-4 h-4 justify-center items-center">
            <IoIosArrowDown
            className={`${show? "" : "rotate-180"}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                close();
              }}
            />
          </div>
        </div>
        {show ? (
          <div className="flex gap-2 items-center border-t px-4 py-2 ">
            <BsClockHistory className="text-md animate-pulse" />
            <span className="text-md font-medium">
              Trial Period Active
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
      <CommonModal
        modalSize="xl"
        onClose={closeModal}
        show={showModal}
        headerTitle={"Trial Information"}
      >
        <ExpiryCountdown expiryDate={expiryDate} />
      </CommonModal>
    </div>
  );
};

export default PlanExpiryCountdown;

const ExpiryCountdown = ({ expiryDate }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <Lottie animationData={Clock} loop={true} className="h-32 w-32" />
      <h2 className="text-2xl font-bold text-theme mt-4 mb-2">Trial Period</h2>
      <p className="text-gray-600 text-center mb-4">
        You are currently using the trial version of our application.
      </p>
      <p className="text-sm text-gray-500 text-center">
        Contact us for more information about upgrading your plan.
      </p>
    </div>
  );
};
